import React from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import AllItems from "../components/Views/AllItems.jsx";
import AddForm from "../components/Views/AddForm.jsx";
import EditForm from "../components/Views/EditForm.jsx";
import Container from "./Container.jsx";
import { editButtonTheme as back } from "../config/theme";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import { createFormData } from "../lib/helperFuncs.jsx";
import axios from "axios";

class ConfigurationsContainer extends Container {
    constructor(props) {
        super(props);
        this.initDatasource("configurations");
    }

    updateConfiguration = () => {
        const formDataToSend = createFormData(this.state.currentItem);
        formDataToSend.append("_method", "PUT");
        console.dir(this.state);
        const path =
            this.datasource?.dataPath +
            "/" +
            this.datasource?.modelName +
            "/" +
            this.state.currentItem?.id;

        this.setLoading(() => {
            axios
                .post(path, formDataToSend)
                .then((result) => {
                    alert(result.data.message);
                    this.props.history.push(this.datasource.routes().home);
                })
                .catch((result) => this.handleUpdateError(result.response));
        });
    };

    updateConfigurationWithoutReload = () => {
        const formDataToSend = createFormData(this.state.currentItem);
        formDataToSend.append("_method", "PUT");

        const path =
            this.datasource?.dataPath +
            "/" +
            this.datasource?.modelName +
            "/" +
            this.state.currentItem?.id;

        return axios
            .post(path, formDataToSend)
            .then(() => alert("Успешно сохранено"))
            .catch((result) => this.handleUpdateError(result.response));
    };

    render = () => {
        const notPermitted = this.checkAvailability();

        if (notPermitted) {
            return <Route render={() => <Redirect to="/" replace />} />;
        }

        if (this.props.user) {
            const userType = this.props.user.type;

            if (userType !== "admin") {
                return (
                    <Route render={() => <Redirect to="/hotels" replace />} />
                );
            }
        }

        const { mainId } = { ...this.props.match.params };
        const fields = this.datasource.getSchemaFields();
        const routes = this.datasource.routes();
        const relations = this.datasource.getSchemaRelations();
        const relationsDataSource = this.datasource.relations;
        const controlButtons = this.props.baseEntity && {
            type: back,
            icon: <ArrowBackIcon />,
            caption: "Вернуться",
            link: this.getBackLink(),
        };

        return (
            <Switch>
                <Route path={routes.home} exact>
                    <AllItems
                        title={
                            mainId
                                ? "Список ключей конфигурации"
                                : "Список глобальных ключей конфигурации"
                        }
                        columns={{
                            id: "Id",
                            key: "Параметр",
                            value: "Значение",
                        }}
                        controlButtons={controlButtons}
                        addRoute={routes.add}
                        initAction={this.getAllItems}
                        items={this.state.AllItems}
                        loading={this.state.loading}
                        removeAction={this.removeItem}
                        editAction={this.getEditLink}
                        viewAction={this.getViewLink}
                    />
                </Route>
                <Route path={routes.add()} exact>
                    <AddForm
                        title={"Новая запись конфигурации"}
                        loading={this.state.loading}
                        fields={fields}
                        initAction={this.initCurrentItem}
                        item={this.state.currentItem}
                        getBackLink={this.getBackLink}
                        submitAction={this.addItem}
                        fieldUpdateHandler={this.setFieldValue}
                        errorFields={this.state.error}
                        relations={relations}
                        relationsDataSource={relationsDataSource}
                        setRelationsValue={this.setRelationsValue}
                    />
                </Route>
                <Route path={routes.edit(":id")} exact>
                    <EditForm
                        loading={this.state.loading}
                        initAction={this.getItem}
                        item={this.state.currentItem}
                        fields={fields}
                        errorFields={this.state.error}
                        submitAction={this.updateConfiguration}
                        submitActionApply={
                            this.updateConfigurationWithoutReload
                        }
                        getBackLink={this.getBackLink}
                        fieldUpdateHandler={this.setFieldValue}
                        relations={relations}
                        relationsDataSource={relationsDataSource}
                        defaultValues={this.props.auxData?.service_categories}
                        thisConfiguration={true}
                    />
                </Route>
            </Switch>
        );
    };
}

export default ConfigurationsContainer;
